import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
import { useDarkClasses } from '../../hooks/useDarkClasses';
import { useUserRole } from '../../context/UserRoleContext';
import { getRoleClasses } from '../../utils/roleTheme';
import { useRoleTheme } from '../../hooks/useRoleTheme';
type ArticleCardProps = {
  article: {
    id: number;
    title: string;
    excerpt: string;
    author: string;
    date: string;
    category: string;
    readTime: string;
    image?: string;
  };
};
const ArticleCard = ({
  article
}: ArticleCardProps) => {
  const dk = useDarkClasses();
  const {
    isReader
  } = useUserRole();
  const roleClasses = getRoleClasses(isReader ? 'reader' : 'vendor');
  const rt = useRoleTheme();
  // Role-aware badge colors
  const badgeClasses = isReader ? dk.isDark ? 'bg-indigo-900/40 text-indigo-300' : 'bg-indigo-100 text-indigo-800' : dk.isDark ? 'bg-purple-900/40 text-purple-300' : 'bg-purple-100 text-purple-800';
  return <div className={`${dk.isDark ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-100'} rounded-lg shadow-sm border overflow-hidden hover:shadow-md transition-shadow`} data-id="element-830" data-mp="1xxlbq4eet6p8">
      {article.image && <div className="h-48 overflow-hidden" data-id="element-831" data-mp="mouiewmrbs4r">
          <img src={article.image} alt={article.title} className="w-full h-full object-cover" data-id="element-832" data-mp="mq5myyo113wx" />
        </div>}
      <div className="p-5" data-id="element-833" data-mp="1ef8ssivkambo">
        <div className="flex items-center mb-3" data-id="element-834" data-mp="1eh1y9uufv0i3">
          <span className={`px-2.5 py-0.5 text-xs font-medium ${rt.badgeRadius} ${badgeClasses}`} data-id="element-835" data-mp="1jev2iic6lkfq">
            {article.category}
          </span>
          <span className={`ml-2 text-xs ${dk.isDark ? 'text-gray-400' : 'text-gray-500'}`} data-id="element-836" data-mp="15essfia47vb1">
            {article.date}
          </span>
        </div>
        <h3 className={`text-lg font-semibold mb-2 ${dk.isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-837" data-mp="3q4i3rlbm0yyz">
          {article.title}
        </h3>
        <p className={`text-sm mb-4 ${dk.isDark ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-838" data-mp="20o5zl294ozj6">
          {article.excerpt}
        </p>
        <div className="flex items-center justify-between" data-id="element-839" data-mp="1vqdypiqia32u">
          <div className="flex items-center" data-id="element-840" data-mp="1qy4biagrzh49">
            <div className="text-xs" data-id="element-841" data-mp="1qwtb8kmjgrhw">
              <p className={`font-medium ${dk.isDark ? 'text-gray-200' : 'text-gray-900'}`} data-id="element-842" data-mp="1mwr6u3pf5jyx">
                {article.author}
              </p>
              <p className={`${dk.isDark ? 'text-gray-400' : 'text-gray-500'}`} data-id="element-843" data-mp="1hvlbrz8adkm8">
                {article.readTime}
              </p>
            </div>
          </div>
          <button className={`text-sm font-medium flex items-center ${roleClasses.link}`} data-id="element-844" data-mp="1809wnfsyubdy">
            Read article
            <ChevronRightIcon className="h-4 w-4 ml-1" data-id="element-845" data-mp="1409izxdoy47y" />
          </button>
        </div>
      </div>
    </div>;
};
export default ArticleCard;